/**
 * 默认配置
 * 配置的优先级要低于Pub的配置注入
 */
export default {
  // 老版本自定义业务埋点数据上报地址
  eventApiUrl: 'https://mc.qunhequnhe.com/api/frontend/event',
  // 新版本自定义业务埋点数据上报地址
  newEventApiUrl: 'https://mc.qunhequnhe.com/api/v2/fe/event',
  // 老版本错误监控数据上报地址
  exceptionApiUrl: 'https://mc.qunhequnhe.com/api/frontend/exception',
  // 新版本错误监控数据上报地址
  newExceptionApiUrl: 'https://mc.qunhequnhe.com/api/v2/fe/exception',
  // 性能数据上报地址
  performanceApiUrl: 'https://mc.qunhequnhe.com/api/frontend/performance',
  // 错误栈格式化解析最大解析深度
  maxStackDepth: 10,
  // 单页最大错误日志收集条数
  maxLogCount: 200,
  // 开启错误监控
  initException: true,
  // 开启性能监控
  initPagePerformance: true,
  // 是否获取页面性能数据
  getPagePerformance: true,
  // 是否获取静态资源性能数据
  getResourcePerformance: true,
  // 是否获取Ajax性能数据
  getAjaxPerformance: true,
  // 是否获取Fetch性能数据
  getFetchPerformance: false,
  // 是否收集页面元素页面位置信息
  getViewport: true,
  // 是否收集页面 unhandledrejection 异常
  getUnhandledrejection: true,
  // 当前设备Token的关键字标识
  deviceTokenKey: 'ktrackerid',
  // 发送静态资源性能数据间隔
  debounceThreshold: 5000,
  // 初始化收集页面性能监控数据重试时间间隔
  performanceDelay: 0,
  // hunterid 位数
  trace128bit: false,
  // 是否是国际站页面
  isCoohom: false,
  // 是否开启调试模式
  debug: false,
  // 是否收集 webgl stat 信息
  webglStat: true,
  // 是否自动开启
  autoInit: true,
};
